module.exports = __webpack_public_path__ + "img/score@2x.e75d467f.png";